import React, { useEffect, useState } from "react";
import selecttick from "../../assets/selecttick.svg";
import dot from "../../assets/dot.svg";
import bluetick from "../../assets/bluetick.svg";
import AddContainer from "../../Container/AddContainer/AddContainer";
import { useHistory } from "react-router-dom";
import "./VehicleCollection.css";
import { svgIcons } from "../../../src/Component/PricingPage/Content/icons";
import { deleteVehicle, getAllVehicle } from "../../utils/api";
import Modal from "../../Container/Modal/Modal";
import ModalAction from "../../Container/Modal/ModalAction/ModalAction";
import Dropdown from "../../Container/Dropdown/Dropdown";
import Loading from "../../Container/Loading/Loading";
import Button from "../../Container/Button/Button";
import { ReactComponent as Arrow } from "../../assets/arrow2.svg";

function VehicleCollection() {
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [selectIndex, setSelectIndex] = useState(0);
  const [loading, setloading] = useState(false);
  const [size, setSize] = useState(0);
  const [error, setError] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [modalStatus, setModalStatus] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const history = useHistory();
  useEffect(() => {
    getAllVehicle()
      .then((response) => {
        setVehicleDetails(response.data.data);
        setSize(response.data.data.length);
        if (response.data.data.length === 0) {
          history.push({
            pathname: "/addvehicle",
            state: { data: 0 },
          });
        }
        setloading(true);
      })
      .catch((err) => {
        console.log(err);
        setError(err);
      });
  }, []);
  const addVehicleHandler = () => {
    // history.push("/addvehicle");
    history.push({
      pathname: "/addvehicle",
      state: { data: 2 },
    });
  };
  const vehicleCollectionHandler = (index) => {
    setSelectIndex(index);
  };

  const editHandler = (id) => {
    // setShowDropdown(false);
    history.push({
      pathname: `/editvehicle/${id}`,
      state: { data: 2 },
    });
  };
  const deleteHandler = (id) => {
    setDeleteId(id);
    setModalStatus(true);
    // setShowDropdown(false);
  };
  const actionModalHandler = (e) => {
    deleteVehicle(deleteId)
      .then((response) => {
        if (response.data.status === true) {
          setDeleteStatus(true);
          setModalStatus(false);
          e.preventDefault();
        }
      })
      .catch((err) => {
        console.log(err);
        setError(err);
      });
  };

  const dropdownHandler = (id) => {
    setVehicleDetails(
      vehicleDetails.map((el) =>
        el._id === id ? Object.assign({}, el, { showDropdown: true }) : el
      )
    );
  };

  const onblurhandler = (id) => {
    setVehicleDetails(
      vehicleDetails.map((el) =>
        el._id === id ? Object.assign({}, el, { showDropdown: false }) : el
      )
    );
  };

  const backwardHandler = () => {
    history.push("myaccount");
  };

  const closeModalHandler = () => {
    setModalStatus(false);
  };
  const deleteSuccessHandler = (e) => {
    setDeleteStatus(false);
    window.location.reload(false);
    e.preventDefault();
  };

  return (
    <>
      {error ? (
        "Something went Wrong"
      ) : (
        <>
          {modalStatus ? (
            <Modal>
              <div>
                <div className="actionHeader">Do you want to Delete?</div>
              </div>
              <ModalAction
                action={actionModalHandler}
                close={closeModalHandler}
              />
            </Modal>
          ) : (
            ""
          )}
          {deleteStatus ? (
            <Modal>
              <div>
                <div className="actionHeader">Successfully deleted</div>
              </div>
              <ModalAction close={deleteSuccessHandler} action={false} />
            </Modal>
          ) : (
            ""
          )}
          {!loading ? (
            <Loading />
          ) : (
            <div className="vehicleCollection-placer">
              <div className="vehicleCollection-header">
                <h2>SELECT YOUR VEHICLE</h2>
              </div>
              <div className="vehicleCollection-divider-card">
                {vehicleDetails &&
                  vehicleDetails.map((item) => {
                    const matchingObject = svgIcons.find(
                      (obj) => obj.id === item.bodytype._id
                    );
                    return (
                      <div
                        key={item._id}
                        onClick={() => vehicleCollectionHandler(item._id, item)}
                        className="vehicleCollection-card "
                      >
                        <div className="vehicleCollection-tick">
                          {selectIndex === item._id ? (
                            <img src={bluetick} alt="" />
                          ) : (
                            <img src={selecttick} alt="" />
                          )}
                        </div>
                        <div
                          className="dropdown-container"
                          tabIndex={0}
                          onBlur={() => onblurhandler(item._id)}
                        >
                          <div
                            className="vehicleCollection-dot"
                            onClick={() => dropdownHandler(item._id)}
                          >
                            <img src={dot} alt="" />
                          </div>
                          <Dropdown
                            show={item.showDropdown}
                            edit={() => editHandler(item._id)}
                            delete={() => deleteHandler(item._id)}
                          />
                        </div>
                        <div className="vehicleCollection-vehicle">
                          <div className="vehicleCollection-carlogo">
                            <img
                              src={matchingObject && matchingObject.selected}
                              alt=""
                            />
                          </div>
                          <div className="vehicleCollection-card-section">
                            <div className="vehicleCollection-card-details">
                              <span
                                className="span-shadow"
                                style={{
                                  fontWeight: "bold",
                                  opacity: 0.7,
                                  paddingRight: "1em",
                                }}
                              >
                                Name :
                              </span>
                              <span style={{ fontWeight: "900", opacity: 0.5 }}>
                                {item && item.nickname}
                              </span>
                            </div>
                            <div className="vehicleCollection-card-details">
                              <span
                                className="span-shadow"
                                style={{
                                  fontWeight: "bold",
                                  opacity: 0.7,
                                  paddingRight: "1em",
                                }}
                              >
                                Make :
                              </span>
                              <span style={{ fontWeight: "900", opacity: 0.5 }}>
                                {item && item.make}
                              </span>
                            </div>
                            <div className="vehicleCollection-card-details">
                              <span
                                className="span-shadow"
                                style={{
                                  fontWeight: "bold",
                                  opacity: 0.7,
                                  paddingRight: "1em",
                                }}
                              >
                                Type :
                              </span>
                              <span style={{ fontWeight: "900", opacity: 0.5 }}>
                                {item && item.bodytype.bodytypeName}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <>
                {size <= 4 ? (
                  <AddContainer onClickHandler={addVehicleHandler}>
                    Add New Vehicle
                  </AddContainer>
                ) : (
                  ""
                )}
              </>
              <div className="back-submit">
                <div>
                  <Button
                    onClickEvent={backwardHandler}
                    style={{
                      gridGap: "1em",
                      display: "flex",
                      borderRadius: "5px",
                      backgroundColor: "#17B3F0",
                    }}
                  >
                    <Arrow
                      className="arrow-button"
                      style={{
                        transform: "rotate(180deg)",
                      }}
                      fill="#03577B"
                      stroke="#03577B"
                    />
                    <div>Back</div>
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default VehicleCollection;
